import React from "react";
import { Card, CardBody, Row, Col, Input, Label, FormGroup } from "reactstrap";
import { StepComponentProps } from "../types/proposalForm.types";

const Step1ProposalDetails: React.FC<StepComponentProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  const paymentModes: Array<"Cash" | "Cheque" | "Telex transfer" | "Demand Draft"> = [
    "Cash",
    "Cheque",
    "Telex transfer",
    "Demand Draft",
  ];

  const renderInput = (
    name: keyof typeof values,
    label: string,
    type: "text" | "number" | "date" | "email" | "tel" = "text",
    placeholder?: string
  ) => (
    <FormGroup className="form-group">
      <Label>{label}</Label>
      <Input
        type={type}
        name={name as string}
        value={String(values[name] || "")}
        onChange={handleChange}
        onBlur={handleBlur}
        invalid={!!(touched[name] && errors[name])}
        placeholder={placeholder}
        className="form-control"
      />
      {touched[name] && errors[name] && (
        <div className="invalid-feedback">{errors[name]}</div>
      )}
    </FormGroup>
  );

  return (
    <Card className="form-card shadow-sm border-0">
      <CardBody>
        <h5 className="form-title">Proposal & Policy Details</h5>
        <p className="form-subtitle">
          Please provide the basic information about your insurance proposal.
        </p>

        <Row>
          <Col md={4}>{renderInput("inward_number", "Inward No.", "text", "XXX")}</Col>
          <Col md={4}>
            <FormGroup className="form-group">
              <Label>Date of Inward</Label>
              <div className="date-input-wrapper">
                <Input
                  type="date"
                  name="date_of_inward"
                  value={values.date_of_inward || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  invalid={!!(touched.date_of_inward && errors.date_of_inward)}
                  className="form-control"
                  id="date-date_of_inward"
                />
                <i 
                  className="ri-calendar-line calendar-icon"
                  onClick={() => {
                    const input = document.getElementById("date-date_of_inward") as HTMLInputElement;
                    if (input) {
                      if (input.showPicker) {
                        input.showPicker();
                      } else {
                        input.click();
                      }
                    }
                  }}
                />
              </div>
              {touched.date_of_inward && errors.date_of_inward && (
                <div className="invalid-feedback">{errors.date_of_inward}</div>
              )}
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="form-group">
              <Label>Date of Proposal</Label>
              <div className="date-input-wrapper">
                <Input
                  type="date"
                  name="date_of_proposal"
                  value={values.date_of_proposal || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  invalid={!!(touched.date_of_proposal && errors.date_of_proposal)}
                  className="form-control"
                  id="date-date_of_proposal"
                />
                <i 
                  className="ri-calendar-line calendar-icon"
                  onClick={() => {
                    const input = document.getElementById("date-date_of_proposal") as HTMLInputElement;
                    if (input) {
                      if (input.showPicker) {
                        input.showPicker();
                      } else {
                        input.click();
                      }
                    }
                  }}
                />
              </div>
              {touched.date_of_proposal && errors.date_of_proposal && (
                <div className="invalid-feedback">{errors.date_of_proposal}</div>
              )}
            </FormGroup>
          </Col>

          <Col md={6}>
            {renderInput("consultant_name", "Name of Consultant", "text", "Type here")}
          </Col>
          <Col md={6}>
            {renderInput("consultant_code", "Consultant Code No.", "text", "XXX")}
          </Col>

          <Col md={6}>
            {renderInput("chief_agent_name", "Chief Agent Name", "text", "Type here")}
          </Col>
          <Col md={6}>
            {renderInput("chief_agent_number", "Chief Agent No.", "text", "XXX")}
          </Col>

          <Col md={3}>
            <FormGroup className="form-group">
              <Label>Proposal Deposit Currency</Label>
              <Input
                type="select"
                name="proposal_deposit_currency"
                value={values.proposal_deposit_currency || ""}
                onChange={handleChange}
                invalid={
                  !!(touched.proposal_deposit_currency && errors.proposal_deposit_currency)
                }
                className={`form-control ${values.proposal_deposit_currency ? "has-value" : ""}`}
                onBlur={handleBlur}
              >
                <option value="">Select</option>
                <option value="BD">BD</option>
                <option value="INR">INR</option>
              </Input>
              {touched.proposal_deposit_currency && errors.proposal_deposit_currency && (
                <div className="invalid-feedback">
                  {errors.proposal_deposit_currency}
                </div>
              )}
            </FormGroup>
          </Col>
          <Col md={3}>
            {renderInput("proposal_deposit_amount", "Proposal Deposit Amount", "number", "123")}
          </Col>
          <Col md={3}>
            {renderInput("proposal_number", "Proposal No.", "text", "XXX")}
          </Col>
        </Row>

        <div className="payment-mode-section">
          <Label className="payment-mode-label">
            Proposal Deposit Amount Type (Select One)*
          </Label>
          <div className="payment-mode-buttons">
            {paymentModes.map((mode) => (
              <button
                key={mode}
                type="button"
                onClick={() => setFieldValue("depositamttype", mode)}
                className={`payment-mode-btn ${values.depositamttype === mode ? "active" : ""}`}
              >
                {mode}
              </button>
            ))}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Step1ProposalDetails;

